import { RepeatTypes, TMeetingSetup } from '@utils';

export const getRepeatType = (meetingSetup: TMeetingSetup) => {
  if (meetingSetup && meetingSetup.expDate) {
    return RepeatTypes.DATE;
  } else if (meetingSetup && meetingSetup.numberOfRepeat > 0) {
    return RepeatTypes.NUMBER;
  }
  return RepeatTypes.NEVER;
};
